
document.addEventListener('DOMContentLoaded', () => {
    const topImageSection = document.getElementById('topImageSection');
    if (!topImageSection) {
        console.error('Element with ID "topImageSection" not found.');
        return;
    }

    const backgroundImages = topImageSection.querySelectorAll('.top-image-background-img');
    if (backgroundImages.length === 0) {
        console.warn('No background images found in "topImageSection".');
        return;
    }

    let currentIndex = 0;
    const intervalTime = 5000; // 切り替えの間隔（ミリ秒）

    // 最初の画像をアクティブにする（HTMLで既に設定されている場合もあるが、念のため）
    if (!topImageSection.querySelector('.top-image-background-img.is-active')) {
        backgroundImages[0].classList.add('is-active');
    } else {
        // 既にアクティブな画像がある場合、そのインデックスを見つける
        const activeImage = topImageSection.querySelector('.top-image-background-img.is-active');
        currentIndex = Array.from(backgroundImages).indexOf(activeImage);
        if (currentIndex === -1) { // 見つからなかった場合
            currentIndex = 0;
            backgroundImages[0].classList.add('is-active');
        }
    }


    function changeImage() {
        // 現在アクティブな画像を非アクティブにする
        const currentActive = topImageSection.querySelector('.top-image-background-img.is-active');
        if (currentActive) {
            currentActive.classList.remove('is-active');
        }

        // 次の画像を選択してアクティブにする
        currentIndex = (currentIndex + 1) % backgroundImages.length;
        backgroundImages[currentIndex].classList.add('is-active');
    }

    // 一定時間ごとに changeImage 関数を実行
    setInterval(changeImage, intervalTime);

    // ウィンドウのリサイズ時に画像の表示を調整する必要がある場合（オプション）
    window.addEventListener('resize', () => {
        // ここにリサイズ時の処理を追加できます
        // 例: 画像のobject-fitが正しく適用されているか確認するなど
    });
});
